import React from "react";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Services from "./components/Services";
import Menus from "./components/Menus";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import WhatsappFloat from "./components/WhatsappFloat";
import ContactUs from "./components/ContactUs";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800, // Animation duration (ms)
      once: true,    // Whether animation should happen only once
    });
  }, []);
  return (
    <div className="main-wrapper">
      <Header />
      <Banner />
      <Services />
      <Menus />
      <Gallery />
      <Footer />
      <WhatsappFloat />
    </div>
  );
}

export default App;
